import { RedactionCodesState } from './models';
import { DEFAULT_PER_PAGE } from '@helpers/constants';

export const defaultState: RedactionCodesState = {
  isDrawerOpen: false,
  redactionCodes: {},
  isFetchingCodes: false,
  limit: DEFAULT_PER_PAGE,
  offset: 0,
  countRedactionCodes: 0,
};

export const namespace = 'vtn-redact-state-redaction-codes';

export interface RedactionCodesStore {
  [namespace]: RedactionCodesState;
}
